import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { StatusDot } from '@/components/Page';
import { formatBRL, formatData } from '@/lib/format';
import { textoDoMotivo } from '@/lib/credito';

// Bloco "Crédito BCMED" do resumo do pedido/proposta: o saldo do cliente (nova_campanha), o máximo neste pedido e o
// valor que o vendedor aplica. Não aplica sozinho. Sem saldo conhecido (documento inválido, integração desligada)
// não aparece; nova_campanha fora mostra o estado e o pedido segue sem crédito. Quando o Cash Black não entra no
// pedido (regras.motivo), diz por quê; o link do regulamento vem do saldo (só https).
const CreditoBcmed = ({ saldo, indisponivel, valor, onValor, limite, travado }) => {
  if (!indisponivel && !saldo?.habilitado && !travado) return null;
  const semSaldo = saldo?.habilitado && !(Number(saldo.disponivel) > 0) && !(Number(valor) > 0);
  const motivo = !travado && !indisponivel && textoDoMotivo(saldo?.regras?.motivo);

  return (
    <div className="mt-4 border-t border-border pt-4" data-testid="credito-bcmed">
      <div className="flex items-baseline justify-between gap-3">
        <span className="text-sm font-semibold text-slate-900 dark:text-slate-100">Crédito BCMED</span>
        {saldo?.habilitado && (
          <span className="text-xs tabular-nums text-muted-foreground">disponível {formatBRL(saldo.disponivel)}</span>
        )}
      </div>
      {travado ? (
        <p className="mt-1 text-xs text-muted-foreground">
          {formatBRL(valor)} aplicado. Pedido com pagamento registrado: o crédito não muda.
        </p>
      ) : indisponivel ? (
        <StatusDot tone="att" className="mt-2">Crédito indisponível agora</StatusDot>
      ) : semSaldo ? (
        <p className="mt-1 text-xs text-muted-foreground">Cliente sem Crédito BCMED disponível.</p>
      ) : (
        <>
          <p className="mt-1 text-xs tabular-nums text-muted-foreground">
            Máximo neste pedido {formatBRL(limite)} (até {saldo.cap_pct}% dos produtos)
            {saldo.validade_em ? ` · válido até ${formatData(saldo.validade_em)}` : ''}
          </p>
          <div className="mt-2 flex gap-2">
            <Input
              aria-label="Valor do Crédito BCMED"
              inputMode="decimal"
              placeholder="0,00"
              value={valor}
              onChange={(e) => onValor(e.target.value)}
              className="tabular-nums"
              data-testid="input-credito-bcmed"
            />
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="h-10 shrink-0"
              disabled={!(limite > 0)}
              onClick={() => onValor(String(limite))}
            >
              Usar o máximo
            </Button>
          </div>
        </>
      )}
      {motivo && (
        <p className="mt-2 text-xs text-muted-foreground" data-testid="credito-cash-black-motivo">{motivo}</p>
      )}
      {saldo?.regulamento_url && (
        <a
          href={saldo.regulamento_url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 inline-block text-xs font-medium text-blue-600 underline-offset-2 hover:underline focus-visible:underline focus-visible:outline-none dark:text-blue-400"
        >
          Regulamento do Cash Black
        </a>
      )}
    </div>
  );
};

export default CreditoBcmed;
